const SkeletonBlock = ({ className = "" }: { className?: string }) => (
  <div className={`contract-project-skeleton__block app-skeleton ${className}`} aria-hidden="true">
    <span className="contract-project-skeleton__wave app-skeleton__wave" />
  </div>
);

export function ProjectFormSkeleton() {
  return (
    <section
      className="contract-project-skeleton app-loading-state"
      role="status"
      aria-label="Loading project information form"
    >
      <span className="visually-hidden">Loading project information form</span>

      <div className="contract-project-skeleton__header">
        <div>
          <SkeletonBlock className="contract-project-skeleton__title" />
          <SkeletonBlock className="contract-project-skeleton__description" />
        </div>
        <SkeletonBlock className="contract-project-skeleton__guide" />
      </div>

      <div className="contract-project-skeleton__fields">
        <SkeletonBlock className="contract-project-skeleton__field" />
        <SkeletonBlock className="contract-project-skeleton__field" />
        <SkeletonBlock className="contract-project-skeleton__field contract-project-skeleton__field--wide" />
        <SkeletonBlock className="contract-project-skeleton__field" />
        <SkeletonBlock className="contract-project-skeleton__field" />
        <SkeletonBlock className="contract-project-skeleton__field contract-project-skeleton__field--wide" />
      </div>

      <div className="contract-project-skeleton__section">
        <SkeletonBlock className="contract-project-skeleton__section-title" />
        <SkeletonBlock className="contract-project-skeleton__section-copy" />
        <div className="contract-project-skeleton__section-fields">
          <SkeletonBlock className="contract-project-skeleton__field" />
          <SkeletonBlock className="contract-project-skeleton__field" />
        </div>
      </div>
    </section>
  );
}
